import React from 'react';
import { motion } from 'framer-motion';
import { statsData } from '../data/siteData';

const StatsSection = () => {
  const { sectionTag, title, subtitle, stats } = statsData;

  return (
    <section className="py-24 lg:py-32 border-t border-white/10" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 text-center">
          <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#FF7A00]/70 mb-4 block">{sectionTag}</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight max-w-3xl mx-auto mb-4">{title}</h2>
          <p className="text-base text-white/40 max-w-2xl mx-auto">{subtitle}</p>
        </div>

        <div className="border border-white/10 rounded-2xl overflow-hidden grid grid-cols-2 lg:grid-cols-3">
          {stats.map((s, i) => {
            // 2-col mobile: right border on even items, bottom border on all except last row
            // 3-col desktop: right border on non-last-in-row, bottom border on first row
            const isLastRow2 = i >= stats.length - (stats.length % 2 === 0 ? 2 : 1);
            const isLastRow3 = i >= stats.length - (stats.length % 3 === 0 ? 3 : stats.length % 3);
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className={[
                  'p-8 lg:p-10',
                  // Mobile (2-col): right border on left column
                  i % 2 === 0 ? 'border-r border-white/10' : '',
                  // Mobile: bottom border on all except last row
                  !isLastRow2 ? 'border-b border-white/10' : '',
                  // Desktop overrides
                  'lg:border-r lg:border-b-0',
                  i % 3 === 2 ? 'lg:border-r-0' : '',
                  !isLastRow3 ? 'lg:border-b' : '',
                ].join(' ')}
                style={{}}
              >
                <div className="font-mono text-3xl lg:text-4xl font-bold gradient-text mb-2">{s.stat}</div>
                <div className="text-sm font-semibold text-white mb-1">{s.label}</div>
                <p className="text-xs text-white/30">{s.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
